export default "__VITE_ASSET__9tiL0y9J__"